import { AlertTriangle, Check, Info } from "lucide-react";

import {
  HONESTY_LINE,
  presentVerdict,
  VerdictPresentation,
  VerdictTone,
} from "lib/nfcVerdict";
import { NfcVerdict } from "services/pcgPublic";

/*
  The band shown once, on a fresh /t tap (P2 wires the mutation; P4 wires this into
  GradeReportView behind readVerdict's router-state gate — R9/D14: a report reached
  without a tap shows nothing about verification, so this component is never rendered
  bare on a normal report view).

  Tone classes read the existing --pcg-success / --pcg-info / --pcg-danger tokens
  (tailwind.config.js:74-76) — no new colours, per REQ-042 / global-constraints.md.
*/

const TONE_CLASSES: Record<VerdictTone, string> = {
  success: "border-pcg-success text-pcg-success",
  info: "border-pcg-info text-pcg-info",
  danger: "border-pcg-danger text-pcg-danger",
};

const TONE_ICONS: Record<VerdictPresentation["icon"], typeof Check> = {
  check: Check,
  info: Info,
  alert: AlertTriangle,
};

export const VerdictBand = ({ verdict }: { verdict: NfcVerdict }) => {
  const presentation = presentVerdict(verdict);
  const Icon = TONE_ICONS[presentation.icon];

  return (
    <div
      data-testid="nfc-verdict-band"
      data-tone={presentation.tone}
      className={`flex items-start gap-3 rounded-md border p-4 ${
        TONE_CLASSES[presentation.tone]
      }`}
    >
      <Icon aria-hidden="true" className="h-6 w-6 shrink-0" />
      <div>
        <p className="font-semibold">{presentation.label}</p>
        <p className="text-sm">{presentation.detail}</p>
        <p className="mt-1 text-sm text-pcg-textMuted">{HONESTY_LINE}</p>
      </div>
    </div>
  );
};
